import { render, staticRenderFns } from "./corporate-shareholders.vue?vue&type=template&id=0a0f3f0c"
import script from "./corporate-shareholders.vue?vue&type=script&lang=js"
export * from "./corporate-shareholders.vue?vue&type=script&lang=js"
import style0 from "./corporate-shareholders.vue?vue&type=style&index=0&id=0a0f3f0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports